import React from 'react';
import {
  canAccessCompensation,
  canAccessCorporate,
  canAccessGate,
  canAccessParking,
  canAccessProducts,
  canAccessUserManagement,
  isOpsScanner,
  isParking,
  isTicketTaker,
  usesSearchHome,
} from '../utils/roles';

const PRIMARY_LINKS = [
  { id: 'dashboard', label: 'Home' },
  { id: 'cases', label: 'Cases' },
  { id: 'search', label: 'Search' },
  { id: 'submit', label: 'Submit' },
  { id: 'season-pass', label: 'Season Pass' },
  { id: 'orders', label: 'Orders' },
];

const SEARCH_HOME_LINKS = [
  { id: 'search', label: 'Home' },
  { id: 'orders', label: 'Orders' },
];

const GATE_LINKS = [{ id: 'gate', label: 'Gate' }];
const PARKING_LINKS = [{ id: 'parking', label: 'Parking' }];

const CORPORATE_LINKS = [{ id: 'corporate', label: 'Companies' }];

function AppNav({ user, onNavigate, onLogout, active }) {
  const activeId =
    active === 'season-pass-detail' ? 'season-pass' : active;

  let links = PRIMARY_LINKS;
  if (canAccessCorporate(user)) {
    links = CORPORATE_LINKS;
  } else if (isTicketTaker(user)) {
    links = GATE_LINKS;
  } else if (isParking(user)) {
    links = PARKING_LINKS;
  } else if (usesSearchHome(user)) {
    links = SEARCH_HOME_LINKS;
  }

  return (
    <nav className="app-nav" aria-label="Main">
      <div className="app-nav-links">
        {links.map((link) => (
          <button
            key={link.id}
            type="button"
            className={`app-nav-link${activeId === link.id ? ' active' : ''}`}
            onClick={() => onNavigate(link.id)}
          >
            {link.label}
          </button>
        ))}
        {!isOpsScanner(user) && canAccessCompensation(user) && (
          <button
            type="button"
            className={`app-nav-link${activeId === 'compensation' ? ' active' : ''}`}
            onClick={() => onNavigate('compensation')}
          >
            Compensation
          </button>
        )}
        {!isOpsScanner(user) && canAccessProducts(user) && (
          <button
            type="button"
            className={`app-nav-link${activeId === 'products' ? ' active' : ''}`}
            onClick={() => onNavigate('products')}
          >
            Products
          </button>
        )}
        {!isOpsScanner(user) && canAccessUserManagement(user) && (
          <button
            type="button"
            className={`app-nav-link${activeId === 'users' ? ' active' : ''}`}
            onClick={() => onNavigate('users')}
          >
            Admin
          </button>
        )}
        {!isOpsScanner(user) && canAccessGate(user) && (
          <button
            type="button"
            className={`app-nav-link${activeId === 'gate' ? ' active' : ''}`}
            onClick={() => onNavigate('gate')}
          >
            Gate
          </button>
        )}
        {!isOpsScanner(user) && canAccessParking(user) && (
          <button
            type="button"
            className={`app-nav-link${activeId === 'parking' ? ' active' : ''}`}
            onClick={() => onNavigate('parking')}
          >
            Parking
          </button>
        )}
      </div>
      <button type="button" className="app-nav-logout" onClick={onLogout}>
        Log out
      </button>
    </nav>
  );
}

export default AppNav;
